// GoogleHotels.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const GoogleHotels = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=es",
    en: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=en",
    ru: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=ru",
    de: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=de",
    fr: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=fr",
    pt: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=pt",
    nl: "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews?hl=nl",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-google icon-space" />
        Google Hotels
      </button>
      {showModal && (
        <LanguageModal
          title="Google Hotels"
          icon="bi bi-google"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default GoogleHotels;
